import React, { Component } from 'react'
import { Modal, Form, Input, Button } from 'antd'

class channelDirectoryCreateModal extends Component {
  state = {
    loading: false
  }

  handleOk = (e) => {
    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true
        })

        this.props.createStorageDirectoryById(this.props.id, {
          name: values.name
        }).then((response) => {
          this.setState({
            loading: false
          })
          this.handleCancel()
        })
      }
    })
  }

  handleCancel = (e) => {
    this.props.closeModal()
  }

  render () {
    const { loading } = this.state
    const { getFieldDecorator } = this.props.form

    const layout = {
      labelCol: {
        md: { span: 8 }
      },
      wrapperCol: {
        md: { span: 16 }
      }
    }

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Add Folder'
        visible={this.props.status}
        onCancel={this.handleCancel}
        destroyOnClose
        width={380}
        footer={[
          <Button key='back' onClick={this.handleCancel}>Cancel</Button>,
          <Button key='submit' type='indigo' loading={loading} onClick={this.handleOk}>Add</Button>
        ]}
      >
        <Form onSubmit={this.handleOk} className='form'>
          <Form.Item {...layout} label='Folder Name'>
            {getFieldDecorator('name', {
              rules: [{ required: true,
                message: 'Please input folder name',
                max: 23,
                pattern: /^[^, ][ a-zA-Z_\\-\\.0-9]*/
              }]
            })(
              <Input name='name' maxLength={23} />
            )}
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}

export default Form.create()(channelDirectoryCreateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelDirectoryCreateModal/ChannelDirectoryCreateModal.jsx